import React from "react";
import { useTranslation } from "react-i18next";
import { PostalAreaActions } from "us.collection.admin/components/PostalAreas/constants";
import { PostalArea } from "us.common/reducers/PostalAreas/types";
import { EditOutlined, DeleteOutlined, CloseCircleFilled } from "us.icons";
import { $Popconfirm } from "us.common/components";

type ItemMenuProps = {
  onMenuClick: (actionType: PostalAreaActions, record: PostalArea) => void;
  record: any;
};

const ItemMenu: React.FC<ItemMenuProps> = ({
  onMenuClick,
  record,
}) => {
  const { t } = useTranslation();

  return (
    <div className="table-more-content" data-testid="popover-content">
      <div
        className="d-flex flex-row more-item"
        data-testid="edit-btn"
        onClick={() => {
          onMenuClick(PostalAreaActions.EDIT, record);
        }}
      >
        <div className="p-1">
          <EditOutlined />
        </div>
        <div className="p-1">{t("US.COLLECTION.COMMON:COMMON.EDIT")}</div>
      </div>
      
      {
        <$Popconfirm
          title={t("US.COMMON:COMMON.DO_YOU_WANT_TO_DELETE_THE_POSTAL_AREA")}
          onConfirm={() => {
            onMenuClick(PostalAreaActions.DELETE, record);
          }}
        >
          <div
            className="d-flex mb-2 flex-row more-item text-error"
            data-testid="delete-btn"
          >
            <div className="p-1">
              <DeleteOutlined />
            </div>
            <div className="p-1">{t("US.COMMON:COMMON.DELETE")}</div>
          </div>
        </$Popconfirm>
      }
    </div>
  );
};

export default ItemMenu;
